import { fetchData } from '../utils';
import { ApiResponse } from '../types';
import { OFFLINE } from './setup';

interface Budget {
  value: number;
  currency: string;
}

export interface OOHRow {
  budget: Budget;
  format: string;
  isRequired: boolean;
  variant: string;
  isIncludedInCalculations: boolean;
}

export interface OOHBudget {
  isRequired: boolean;
  data: OOHRow[];
}

export const getOOHBudget = async (
  campaignScenario: string,
  targetGroup: string,
  countryISO: string,
  division: string,
  brand: string,
  category: string
) => {
  return fetchData<ApiResponse<OOHBudget>>(
    `/${OFFLINE}/ooh?campaignScenario=${campaignScenario}&targetGroup=${targetGroup}&countryISO=${countryISO}&division=${division}&brand=${brand}&category=${category}`
  );
};
